import React from 'react';
import { motion } from 'framer-motion';
import { KeyRound } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function SessionExpiredModal() {
  const { reauthWithRedirect } = useAuth();

  return (
    <div
      data-testid="session-expired-modal"
      className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: 8 }}
        animate={{ opacity: 1, scale: 1,    y: 0 }}
        className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-sm text-center"
      >
        <div className="w-14 h-14 bg-amber-50 rounded-2xl flex items-center justify-center mx-auto mb-5">
          <KeyRound className="w-7 h-7 text-amber-500" />
        </div>

        <h2 className="text-lg font-bold text-slate-900 font-outfit mb-2">
          Session Expired
        </h2>
        <p className="text-slate-500 text-sm leading-relaxed mb-7">
          Your login session has expired.
          <br />Please sign in again to continue.
        </p>

        <button
          data-testid="session-expired-signin-btn"
          onClick={reauthWithRedirect}
          className="w-full py-3 rounded-2xl bg-sky-500 hover:bg-sky-600 active:scale-[0.98] text-white font-semibold text-sm transition-all"
        >
          Sign In Again
        </button>
      </motion.div>
    </div>
  );
}
